import { call, put, takeLatest } from "redux-saga/effects";
import get from "lodash/get";
import { history } from "store";
import Requester from "common/network/http/Request";
import EstimateOverviewActions, { EstimateOverviewTypes } from "reducers/EstimateOverviewRedux";
import endpoints from "configs/endpoints";
import getSoilIndexByState from "themes/cashrent/components/map-common/SoilData/getSoilIndexByState";
import { redirectToCG } from "../utils/router";
import { message } from "antd";

function* handleEstimateOverviewRequest(action) {
  const { id } = action;

  const result = yield call(
    Requester.get.bind(Requester),
    endpoints.estimate.getOverview(id),
  );
  const error = get(result, "data.error");

  if (!error) {
    const { farm, estimateRequest, location, autoValues, stateValues } = result;

    yield put(EstimateOverviewActions.requestEstimateOverviewSuccess({
      farm,
      estimateRequest,
      location,
      autoValues,
      stateValues,
    }));
    yield put(EstimateOverviewActions.fetchSoilFeatures(result));
  } else {
    if (error === "Resource not found") {
      yield call(history.push, "/");
    }
    yield put(EstimateOverviewActions.requestEstimateOverviewFailure());
  }
}

function* handleCreateListingFromEstimate(action) {
  const { id } = action;

  try {
    const result = yield call(Requester.post.bind(Requester), endpoints.listing.createFromEstimate(id));

    if (!get(result, "data.error")) {
      yield call(redirectToCG, `/app/listings/update/${result.id}`);
      yield put(EstimateOverviewActions.createListingFromEstimateSuccess());
    } else {
      yield put(EstimateOverviewActions.createListingFromEstimateFailure());
    }
  } catch (err) {
    yield put(EstimateOverviewActions.createListingFromEstimateFailure());
  }
}

function* handleFetchSoilFeatures(action) {
  const { data } = action;
  const { farm, location } = data;

  const timeoutId = setTimeout(() => {
    message.info(
      "CashRentstimate information is taking longer than usual to load, but will be available shortly.",
      5,
    );
  }, 15000);

  try {
    const soilData = yield call(getSoilIndexByState, location.state, farm.soilMap); // TODO: store this to the database

    clearTimeout(timeoutId);

    yield put(EstimateOverviewActions.fetchSoilFeaturesSuccess(soilData));
  } catch (e) {
    message.info("We had issues generating your CashRentstimate. Please try again later.");
  } finally {
    clearTimeout(timeoutId);
  }
}

export default function* () {
  return [
    yield takeLatest(EstimateOverviewTypes.REQUEST_ESTIMATE_OVERVIEW, handleEstimateOverviewRequest),
    yield takeLatest(EstimateOverviewTypes.CREATE_LISTING_FROM_ESTIMATE, handleCreateListingFromEstimate),
    yield takeLatest(EstimateOverviewTypes.FETCH_SOIL_FEATURES, handleFetchSoilFeatures),
  ];
}
